import { useCallback, useEffect, useMemo, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import PaymentsPopup from '../Payments/PaymentsPopup';
import { getString } from '../../../strings';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { BigLoader } from '../../atoms/Loader/StyledBigLoader';
import { getEventDates, updateEventDates } from '../../../logic/requests/events';
import { StyledInputsDivWrapper } from '../../atoms/StyledInputsDivWrapper/StyledInputsDivWrapper';
import { StyledInputWrapper } from '../../../styles/sharedStyles';
import { StyledScrollBarWrapperModal } from './GetThanksModal.styles';

// labelki takie same jak na stronie zawodów (TournamentInformationContent)
const DATE_FIELDS = [
    {
        key: 'register_time_start',
        label: 'userPanel_userPanelTournament_update_dates_register_time_start',
    },
    {
        key: 'register_time_end',
        label: 'userPanel_userPanelTournament_update_dates_register_time_end',
    },
    {
        key: 'pending_deadline',
        label: 'tournament_tournamentInformationContent_ostatecznyTerminAkceptowania',
    },
    {
        key: 'competition_deadline',
        label: 'tournament_tournamentInformationContent_ostatecznyTerminZmianyKonkurencji',
    },
    {
        key: 'payment_return_deadline',
        label: 'tournament_tournamentInformationContent_ostatecznyTerminZawarcia',
    },
];

const UpdateDatesPopup = ({ eventData, onClose }) => {
    const queryClient = useQueryClient();
    const [dates, setDates] = useState();
    const [error, setError] = useState(null);
    const [queryFinished, setQueryFinished] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getEventDates(eventData.id)
            .then(
                (res) => setDates(res),
                (err) => {
                    setError(err);
                    setQueryFinished(true);
                    console.log(err);
                }
            )
            .finally(() => setIsLoading(false));
    }, [eventData.id]);

    const onSubmit = useCallback(() => {
        setIsLoading(true);
        updateEventDates(eventData.id, dates)
            .then(
                (res) => {
                    setError(null);
                    queryClient.invalidateQueries(['allEvents']);
                },
                (err) => {
                    setError(err);
                    console.log(err);
                }
            )
            .finally(() => {
                setQueryFinished(true);
                setIsLoading(false);
            });
    }, [eventData.id, dates, queryClient]);

    const renderContent = useMemo(
        () =>
            queryFinished ? (
                <div>
                    {error ? (
                        <>
                            <StyledText
                                hasdeclaredfontsize="20px"
                                hasdeclaredpadding={'50px 20px 20px 20px'}
                                hasdeclaredlineheight="1.4em"
                                hasdeclaredtextalign="center"
                                hasdeclaredfontcolor="#EE745C"
                                hasdeclaredfontweight="600"
                            >
                                {getString('userPanel_userPanelTournament_update_dates_error')}
                            </StyledText>
                            <StyledText
                                hasdeclaredfontsize="18px"
                                hasdeclaredpadding={'20px 20px 20px 20px'}
                                hasdeclaredlineheight="1.4em"
                                hasdeclaredtextalign="center"
                            >
                                {error.data?.message}
                            </StyledText>
                        </>
                    ) : (
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'50px 20px 20px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                        >
                            {getString('userPanel_userPanelTournament_update_dates_success')}
                        </StyledText>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onClose}
                        >
                            {getString('all_trainer_pay_popup_zamknij')}
                        </StyledButton>
                    </div>
                </div>
            ) : isLoading || !dates ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <BigLoader />
                </div>
            ) : (
                <StyledScrollBarWrapperModal>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'40px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('userPanel_userPanelTournament_update_dates_title')}{' '}
                        {eventData.name}
                    </StyledText>
                    {DATE_FIELDS.map(({ key: field, label }) => (
                        <StyledInputsDivWrapper key={field}>
                            <StyledInputWrapper>
                                <label htmlFor={`update-dates-${field}`}>
                                    <StyledText
                                        hasdeclaredfontsize="20px"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredpadding="8px 0 8px 0"
                                        hasdeclaredfontweight="600"
                                    >
                                        {getString(label)}
                                    </StyledText>
                                </label>
                                <input
                                    id={`update-dates-${field}`}
                                    name={field}
                                    type="datetime-local"
                                    value={dates[field]}
                                    onChange={(e) =>
                                        setDates((prev) => ({ ...prev, [field]: e.target.value }))
                                    }
                                />
                            </StyledInputWrapper>
                        </StyledInputsDivWrapper>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onSubmit}
                        >
                            {getString('userPanel_userPanelTournament_sync_registrations_confirm')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 40px 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onClose}
                        >
                            {getString('userPanel_userPanelTournament_payment_reminder_cancel')}
                        </StyledButton>
                    </div>
                </StyledScrollBarWrapperModal>
            ),
        [onClose, isLoading, onSubmit, error, eventData.name, dates, queryFinished]
    );

    return <PaymentsPopup>{renderContent}</PaymentsPopup>;
};

export default UpdateDatesPopup;
